export default __webpack_public_path__ + "static/media/Lexmark.17d51410.png";